import type { IEquipmentDetails } from '@model/equipmentDetails';

export const getPointInfo = (data?: IEquipmentDetails, type?: string) => {
  if (!data) return null;

  if (type === 'gateway') {
    return {
      id: Number(data.gateway_id),
      label: data.serial.toString(),
      facilityId: data.facility_id,
      serial: data.serial,
      facilityOffset: data.facilityOffset,
    };
  }

  if (type === 'router') {
    return {
      id: Number(data.router_id),
      label: data.serial.toString(),
      facilityId: data.gateway?.facility_id,
      serial: data.serial,
      facilityOffset: data.facilityOffset,
    };
  }

  if (type === 'node') {
    return {
      id: Number(data.node_id),
      label: data.serial.toString(),
      facilityId: data.gateway?.facility_id,
      serial: data.serial,
      facilityOffset: data.facilityOffset,
    };
  }

  return null;
};
